<!-- data table showing leave requests that were submitted -->
<p-table #dt [columns]="tableColumns" [value]="sharedPtables" [paginator]="true" [rows]="10" [responsive]="true">

  <ng-template pTemplate="caption">
    <div class="ui-g-12 ui-md-4 ui-lg-4" style="text-align:left;">
      <!-- add any caption here -->
    </div>

    <div class="leave-request-search ui-g-12 ui-md-4 ui-lg-4" style="text-align:left;">
      <i class="fa fa-search"></i>
      <input type="text" pInputText size="20" placeholder="Table Filter" (input)="dt.filterGlobal($event.target.value, 'contains')">
    </div>
    <div class="ui-g-12 ui-md-4 ui-lg-4" style="text-align:right;">
      <button pButton class="action-secondary" icon="fa-plus" type="button" (click)="onClickAddRow()" pTooltip="Make New Shared Ptable" label="Shared Ptable"
        tooltipPosition="top">
      </button>
    </div>
  </ng-template>

  <ng-template pTemplate="header" let-columns>
    <tr>
      <th *ngFor="let col of columns" [pSortableColumn]="col.field">
        {{col.header}}
        <p-sortIcon [field]="col.field"></p-sortIcon>
      </th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-row let-rowIndex="rowIndex" let-columns="columns">
    <tr>
      <td *ngFor="let col of columns" [ngSwitch]="col.field">
        <!-- show formatted date  -->
        <div *ngSwitchCase="'leaveStartOn'">{{row[col.field] | date: Format.Date }}</div>
        <div *ngSwitchCase="'status'">{{row[col.field] | titleCase }}</div>
        <div *ngSwitchCase="'createdOn'">{{row[col.field] | date: Format.Time }}</div>
        <div *ngSwitchCase="'action'">
          <button pButton class="icon-action" icon="fa-pencil" type="button" (click)="onClickEditRow(row, rowIndex)" pTooltip="Update" tooltipPosition="top">
          </button>
          <button pButton class="icon-negative" icon="fa-trash" type="button" (click)="onClickDeleteRow(rowIndex)" pTooltip="Delete" tooltipPosition="top">
          </button>

        </div>
        <div *ngSwitchDefault>{{row[col.field]}}</div>
      </td>
    </tr>
  </ng-template>
</p-table>

<p-confirmDialog></p-confirmDialog>

<!-- dialog for new COMPONENT_NAME or editing an existing leave request -->
<p-dialog header="COMPONENT_NAME" *ngIf="sharedPtableToEdit" [(visible)]="displayDialog" [responsive]="true" showEffect="fade" [modal]="true"
          [style]="DialogStyle450" [dismissableMask]="true">
  <form #dialogForm="ngForm">

    <!-- <div class="ui-g-12 ui-md-4 ui-lg-4">
      <label for="chargeNumber">Leave Type*</label>
    </div>
    <div class="ui-g-12 ui-md-8 ui-lg-8">
      <p-dropdown [options]="leaveTypeDropdownOptions" placeholder="Select..." [(ngModel)]="sharedPtableToEdit.leaveType" name="selectLeaveType" [style]="{ 'overflow': 'visible', 'width': '100%'}"
        required></p-dropdown>
    </div>

    <div class="ui-g-12 ui-md-4 ui-lg-4">
      <label for="startDate">Start Date*</label>
    </div>
    <div class="ui-g-12 ui-md-8 ui-lg-8">
      <p-calendar [(ngModel)]="sharedPtableToEdit.leaveStartOn" dataType="string" [dateFormat]="Format.PcalendarDate" showIcon="true"
        icon="fa-calendar" name="leaveStartOn" [monthNavigator]="true" [minDate]="minLeaveStartOn" (onSelect)="onSelectStartOn(sharedPtableToEdit)"
        readonlyInput="true" required></p-calendar>
    </div>

    <div class="ui-g-12 ui-md-4 ui-lg-4">
      <label for="endDate">End Date*</label>
    </div>
    <div class="ui-g-12 ui-md-8 ui-lg-8">
      <p-calendar [(ngModel)]="sharedPtableToEdit.leaveEndOn" dataType="string"  [dateFormat]="Format.PcalendarDate" showIcon="true"
        icon="fa-calendar" name="leaveEndOn" [monthNavigator]="true" [minDate]="minLeaveEndOn" readonlyInput="true" required></p-calendar>
    </div>

    <div class="ui-g-12 ui-md-4 ui-lg-4">
      <label for="leaveReason">Leave Reason*</label>
    </div>
    <div class="ui-g-12 ui-md-8 ui-lg-8">
      <textarea rows="2" cols="40" pInputTextarea [(ngModel)]="sharedPtableToEdit.leaveReason" name="leaveReason" [maxlength]="Validation.DescriptionMaxLength"
        required style="width:100%;max-width:225px;">
                </textarea>
      <div style="width:225px;" *ngIf="sharedPtableToEdit.leaveReason?.length >= Validationi.DescriptionMaxLength" class="alert alert-danger">
        {{Validation.MaxNumOfCharsExceeded}}
      </div>
    </div> -->

  </form>

  <p-footer>
    <div class="ui-dialog-buttonpane ui-helper-clearfix">
      <!-- disable it until all required field inclduing chargeCodeId are selected -->
      <button class="button-action" type="button" class="button-action" (click)="onClickSaveRow(sharedPtableToEdit)" [disabled]="!dialogForm.form.valid"
        icon="fa-check">Save</button>
      <button type="button" class="button-inaction" (click)="displayDialog=false">Cancel</button>
    </div>
  </p-footer>
</p-dialog>
